import * as React from 'react';
import { BaseRow, BaseRowFactory } from '../BaseRow';

export class MoreRow extends BaseRow<MoreRowFactory> {
  renderData() {
    return <>
      <a href="https://determiner--full.orz.tools/">https://determiner--full.orz.tools/</a>
    </>
  }
}

export class MoreRowFactory extends BaseRowFactory<typeof MoreRow, {}, {}> {
  generate(input: this['TInput']) {
    return {}
  }

  component = MoreRow
}

